import './writeup.scss';

function Writeup() {
  return (
    <div className="writeup">
      <p>
        <span className="imagination">Imagination</span> is always an intrinsic part of being human. <span className="daydreams">Daydreams</span> are
        teleporting machines, transporting our souls to <span className="bizarre">bizarre</span> and <span className="wonderful">wonderful</span> places.
        Strange Odyssey plays upon this child-like fantasy each of us had when we were children. The innocence of a child's fantasy before adolescence is filled
        with <span className="infinite">infinite joy</span>, <span className="wonders">wonders</span> and <span className="playfulness">playfulness</span>.
      </p>
      <p>
        Strange Odyssey is a gentle reminder to each of us to rekindle our inner child, where the future is <span className="optimistic">optimistic</span> and
        filled with <span className="unlimited">unlimited possibilities</span>, a place bound only by our own imagination.
      </p>
      <hr className="dividerRounded"></hr>
    </div>
  );
}

export default Writeup;
